import { render, staticRenderFns } from "./NavAdmin.vue?vue&type=template&id=081b9d79"
import script from "./NavAdmin.vue?vue&type=script&lang=js"
export * from "./NavAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports